export default function initLazyframe() {
  const elements = document.querySelectorAll(".lazyframe")

  if (elements.length > 0) {
    // Prevent duplicate initialization
    elements.forEach((el) => {
      if (el.dataset.lazyframeBound === "true") return
      el.dataset.lazyframeBound = "true"
    })

    lazyframe(elements)
  }
}
